import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import {
  basketDetailsAction,
  createBasketsAction,
  resetBasketAction,
  resetValidateBasketAction,
  setUserLastActiveTime,
  showCustomizationModalAction,
  validateBasketAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getContentHelpCall from '@kfc-global/react-shared/redux/Actions/HelpAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { fetchMenuAction, recommendedProductAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChannelManager } from 'common/manager';
import _ from 'lodash';
import CartPageComponent from 'organisms/CartPage/Container/CartPageComponent';
import CART_STATES_CONSTANTS from 'organisms/CartStatesModule/Constants/CartStatesConstants';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { Footer } from 'organisms/FooterComponent';
import { Header } from 'organisms/HeaderComponent';
import { MENU_PLP_CONSTANT } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import ProductListingModalOptions from 'organisms/ProductListingModalOptions/Container/ProductListingModalOptionsComponent';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { getCmsClient } from '../../../common/utilities/cmsClient';

import {
  getBasketPayloadforQROrder,
  getDispositionTypeOnAPIFormat,
  getEmptyObjectforNull,
  getFaqData,
  getFooterData,
  getHeaderContentData,
  getHeaderData,
  getPrice,
  getTenantData,
  getTotalprice,
  getValueOrDefaultObject,
  getValueOrnull,
  ifCheckoutAmountFailure,
  ifCheckoutItemFailure,
  isEmptyEvery,
  isEmptyObject,
  isEqualDisposition,
  isQRModeCheck,
  checkForStoreStatus,
} from '../../../common/utilities/utils';
import { UserOrderContext } from '../../../context/context';
import { CartStatesModule } from '../../../organisms/CartStatesModule/index';
import HOME_PAGE_CONTAINER_CONSTANTS from '../Constants/homePageContainerConstants';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';

export const analyzeFoodLine = (foodLineItem, menuJSONData, currencyConversionFactor) => {
  let itemFromCart = JSON.parse(JSON.stringify(foodLineItem));
  let mapToReturn = {
    toRemove: true,
    requireModification: false,
    findings: ['Item not available'],
    newFoodLineItem: itemFromCart,
    menuPrice: undefined,
    cartPrice: itemFromCart.amount / currencyConversionFactor,
  };
  const flatItem = menuJSONData?.[itemFromCart?.item?.id];
  if (flatItem) {
    mapToReturn.findings = [];
    mapToReturn.toRemove = false;
    let getPriceFromMenu = getPrice(flatItem.availability[0], currencyConversionFactor);
    let cartPrice = itemFromCart.amount / currencyConversionFactor;
    let priceFromMenu = getTotalprice(
      getPriceFromMenu,
      itemFromCart.item.modGrps,
      itemFromCart.quantity,
      currencyConversionFactor,
    );
    if (priceFromMenu !== cartPrice) {
      mapToReturn.findings.push(`Item Price has changed Cart Price(${cartPrice}), Menu price(${priceFromMenu})`);
      mapToReturn.requireModification = true;
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
      // If the price has changed pick the item from the new Menu
    } else {
      mapToReturn.menuPrice = priceFromMenu;
      mapToReturn.cartPrice = cartPrice;
      // If the price has not changed use the cart line item as it is
      mapToReturn.newFoodLineItem = itemFromCart;
    }
  }
  return mapToReturn;
};
export const defaultFoodLine = (foodLineItem, currencyConversionFactor) => {
  let itemfromCart = JSON.parse(JSON.stringify(foodLineItem));
  return {
    toRemove: false,
    requireModification: false,
    findings: [],
    newFoodLineItem: itemfromCart,
    menuPrice: undefined,
    cartPrice: itemfromCart.amount / currencyConversionFactor,
  };
};

const navigateToCheckOut = (fromFlag, history) => {
  if (!fromFlag) {
    history.push({
      pathname: '/checkout',
    });
  }
};
const cartvalidationCheck = objForCartValidation => {
  const {
    isValidated,
    navigateToCheckOutObj,
    validationResult,
    validationObj,
    setMenuCallBack,
    validatedCallFromCart,
  } = objForCartValidation;
  let { fromFlag, history } = navigateToCheckOutObj;
  if (isValidated) {
    navigateToCheckOut(fromFlag, history);
  } else {
    validatedCallFromCart && ifCheckoutAmountFailure(validationResult, validationObj);
    !ifCheckoutItemFailure(validationResult) && setMenuCallBack(false);
  }
};

const cartIdAndTenantIdExists = (cartData, tenantId, menuCallBack) => {
  return cartData?.id && tenantId && !menuCallBack ? true : false;
};

export const confirmChangesSubmit = payload => {
  const { unavailableItems, priceChangedItems, createAddValidateBasket, dispatch, cartId, tenantId } = payload;
  if (unavailableItems.length || priceChangedItems.length) {
    createAddValidateBasket();
  } else {
    //validate basket
    dispatch(validateBasketAction({ data: { id: cartId }, tenantId: tenantId }));
  }
};
export const renderCartPageComponet = ({ isLoading, params, cartList, onModalOpen, confirmChangesHandler, dispositionNew, history }) => {
  return (<>
    {!isLoading && <CartPageComponent
      contentData={params}
      cartListContent={cartList}
      isModalOpen={onModalOpen}
      confirmChangesHandler={confirmChangesHandler}
      dispositionData={dispositionNew}
      history={history}
    />
    }
  </>)
}
const CartPageContainer = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();
  const dispatch = useDispatch();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const cartReducer = useSelector(data => data.cartReducer);
  const profileReducer = useSelector(data => data.profileReducer);
  const {
    cartData = {},
    isValidated = false,
    isValidateBasketSuccess = false,
    showProductListingModal = false,
    qrCodeScanTime,
  } = cartReducer || {};
  const { validationResult = {} } = cartData || {};

  const {
    flatResponse: { itemMapById = {} } = {},
    isLoading = false,
    currentItemDetails = {},
  } = getEmptyObjectforNull(useSelector(({ menuReducer }) => menuReducer));
  const { tenantId, currencyConversionFactor, currencySymbol, shouldCheckDropOffAddress } = tenantReducer || {};
  const { CART_STATES_DATA, DISPOSITION_CHANGED_FLAG, STORE_CHANGED_FLAG } = START_ORDER_CONSTANTS;
  const { FROMCONFIRM } = CART_STATES_CONSTANTS;
  const [cartList, setCartList] = useState([]);
  const [fromFlag, setFromFlag] = useState(false);
  const [updateCartList, setUpdatedCartList] = useState([]);
  const [unavailableItems, setUnavailableItems] = useState([]);
  const [priceChangedItems, setPriceChangedItems] = useState([]);
  const [onModalOpen, setOnModalOpen] = useState(false);
  const [menuCallBack, setMenuCallBack] = useState(null);
  const [validatedCallFromCart, setValidatedCallFromCart] = useState(false);
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const { SERVICE_CHANNEL } = MENU_PLP_CONSTANT;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const dispositionOld = isEmptyEvery(userOrderState.dispositionOld)
    ? JSON.parse(localStorage.getItem('dispositionOld'))
    : userOrderState.dispositionOld;
  const { store } = dispositionNew || {};
  const location = useLocation();
  const catalogs =
    (
      store?.summary?.menu?.catalogs?.length &&
      store.summary.menu.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';
  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTenantData = null,
    segmentedFooterData = null,
    segmentedHelpData = null;

  const currentStoreInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_STORE_INFO_STORAGE));
  const serviceType = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE);

  useEffect(() => {
    window?.scrollTo(0, 0);
    const objForStatusCheck = {
      currentStoreInfo,
      serviceType,
      shouldCheckDropOffAddress,
      tenantId,
      dispositionNew,
      dispositionOld,
      dispatch,
      userOrderStateDispatch,
      statusCheckFromCart: true,
    };
    checkForStoreStatus(objForStatusCheck);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * method to setup content data for cart page config
   */
  const allReducerData = useSelector(data => {
    return {
      homePageContent: _.get(data, 'contentReducer.response', null),
      marketPageContent: _.get(data, 'marketConfigReducer.response', null),
      tenantReducerContent: _.get(data, 'tenantReducer', null),
      helpReducerContent: _.get(data, 'helpReducer', null),
    };
  });

  if (
    allReducerData.marketPageContent &&
    allReducerData.tenantReducerContent &&
    allReducerData.homePageContent &&
    allReducerData.helpReducerContent
  ) {
    segmentedHomePageData = getValueOrnull(getHeaderContentData(allReducerData.homePageContent));
    const {
      header = {},
      footer = {},
    } = getValueOrDefaultObject(allReducerData.marketPageContent.headerData);
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
    segmentedHelpData = getValueOrnull(getFaqData(allReducerData.helpReducerContent));
  }
  const params = useMemo(() => {
    return {
      tenantReducer,
      cartReducer,
      segmentedHelpData,
      storeInfo: (dispositionNew?.store) || {},
      dispositionType:
        dispositionNew?.type
          ? getDispositionTypeOnAPIFormat(dispositionNew.type)
          : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
    };
  }, [cartReducer, dispositionNew, segmentedHelpData, tenantReducer]);

  useEffect(() => {
    if (showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  useEffect(() => {
    if (
      currentItemDetails &&
      userOrderState.cartEditClicked &&
      userOrderState.minipdpData.itemId === currentItemDetails.id
    ) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: '',
        }),
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails, userOrderState.minipdpData.itemId, userOrderState.cartEditClicked]);

  useEffect(() => {
    let flag = cartIdAndTenantIdExists(cartData, tenantId, menuCallBack);
    const { customerId } = AuthManager.getInstance();
    if (flag && customerId === cartData?.customer?.id) {
      dispatch(
        basketDetailsAction({
          tenantId: tenantId,
          basketId: cartData.id,
        }),
      );
      dispatch(
        fetchMenuAction(
          {
            tenantId: tenantId,
            catalogName: catalogs,
          },
          {
            storeId: params.storeInfo?.id,
            channel: SERVICE_CHANNEL,
            service: params.dispositionType,
          },
        ),
      );
      setMenuCallBack(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    tenantId,
    cartData?.customer?.id,
    cartData?.id,
    catalogs,
    params.dispositionType,
    params.storeInfo?.id,
    cartReducer?.cartData?.id,
    SERVICE_CHANNEL,
    menuCallBack,
  ]);

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
    dispatch(
      getContentHelpCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          select: 'sys.id,fields',
          'fields.title': 'CartFAQ',
          include: '5',
        },
      }),
    );
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': tenantReducer?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
  }, [dispatch, tenantReducer?.country, userParams]);

  useEffect(() => {
    if (userOrderState.dispositionNew?.type) {
      const recommendedProductsPayload = {
        channel: 'web',
        service: getDispositionTypeOnAPIFormat(userOrderState.dispositionNew?.type),
      };
      dispatch(recommendedProductAction(recommendedProductsPayload));
    }
  }, [dispatch, userOrderState.dispositionNew]);

  const stringyfyDeposition = JSON.stringify(dispositionNew);
  useEffect(() => {
    setOnModalOpen(false);
    const { showDisposition } = userOrderState.dispositionStateData;
    const { showSearchStore } = userOrderState.searchStoreData;
    const { showScheduleOrderCatering } = userOrderState.scheduleOrderData;
    if (
      !showDisposition &&
      !showSearchStore &&
      !showScheduleOrderCatering &&
      dispositionNew &&
      !isEqualDisposition(dispositionOld, dispositionNew)
    ) {
      //check if all props available && userParams localized
      const { type, store: storeVal, date: dateVal, time: timeVal } = dispositionNew;
      if (userParams.localized && type !== '' && storeVal !== '' && dateVal !== '' && timeVal !== '') {
        setOnModalOpen(true);
        dispatch(
          fetchMenuAction(
            {
              tenantId: tenantId,
              catalogName: catalogs,
            },
            {
              storeId: dispositionNew?.store?.id,
              channel: SERVICE_CHANNEL,
              service: dispositionNew?.type
                ? getDispositionTypeOnAPIFormat(dispositionNew.type)
                : getDispositionTypeOnAPIFormat(tenantReducer.authoredContent?.defaultdisposition),
            },
          ),
        );
        userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: true } });
      }
      userOrderStateDispatch({
        type: DISPOSITION_CHANGED_FLAG,
        value: { dispositionChanged: false },
      });
      userOrderStateDispatch({
        type: STORE_CHANGED_FLAG,
        value: { storeChanged: false },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    stringyfyDeposition,
    userParams,
    CART_STATES_DATA,
    DISPOSITION_CHANGED_FLAG,
    SERVICE_CHANNEL,
    STORE_CHANGED_FLAG,
    catalogs,
    dispatch,
    tenantId,
    tenantReducer.authoredContent?.defaultdisposition,
    userOrderState.dispositionStateData,
    userOrderState.scheduleOrderData,
    userOrderState.searchStoreData,
    userOrderStateDispatch,
  ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (itemMapById && currencyConversionFactor && !isLoading) {
      if (cartData?.foodLines?.length > 0) {
        let validationSummaryResult = cartData.foodLines.map(Item => {
          return analyzeFoodLine(Item, itemMapById, currencyConversionFactor);
        });
        if (onModalOpen) {
          let validationDefaultSummaryResult = cartData.foodLines.map(Item => {
            return defaultFoodLine(Item, currencyConversionFactor);
          });
          setCartList(validationDefaultSummaryResult);
        } else {
          setCartList(validationSummaryResult);
        }
        setUpdatedCartList(validationSummaryResult);
        let unavailables = validationSummaryResult.filter(item => item.toRemove);
        setUnavailableItems(unavailables);
        let priceChanged = validationSummaryResult.filter(item => item.requireModification);
        setPriceChangedItems(priceChanged);
      } else {
        setUpdatedCartList([]);
        setCartList([]);
        setUnavailableItems([]);
        setPriceChangedItems([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyConversionFactor, cartData, itemMapById, onModalOpen]);

  const confirmChangesHandler = type => {
    setOnModalOpen(false);
    if (type === FROMCONFIRM) {
      setFromFlag(true);
      let payload = {
        unavailableItems,
        priceChangedItems,
        createAddValidateBasket,
        dispatch,
        cartId: cartData?.id,
        tenantId,
      };
      confirmChangesSubmit(payload);
    } else {
      setFromFlag(false);
      setValidatedCallFromCart(true);
      //validate basket
      dispatch(validateBasketAction({ data: { id: cartData?.id }, tenantId: tenantId }));
    }
  };

  const createAddValidateBasket = async () => {
    //create cart with selected storeinfo
    let newCartItems = [];
    updateCartList.forEach(validationSummaryResultItem => {
      // If this item is to be added to the new cart
      if (!validationSummaryResultItem.toRemove) {
        let addItemObj = {};
        addItemObj.id = validationSummaryResultItem?.newFoodLineItem?.item?.id;
        addItemObj.categoryId = '';
        addItemObj.quantity = validationSummaryResultItem?.newFoodLineItem?.quantity;
        addItemObj.modGrps = validationSummaryResultItem?.newFoodLineItem?.item?.modGrps;
        newCartItems.push(addItemObj);
      }
    });
    dispatch(resetBasketAction());

    const isQRmode = isQRModeCheck(qrCodeScanTime);
    const basketPayload = await getBasketPayloadforQROrder(
      dispatch,
      isQRmode,
      qrCodeScanTime,
      params.storeInfo,
      params.dispositionType,
      profileReducer.customerId,
    );

    tenantId &&
      dispatch(createBasketsAction({ data: basketPayload, tenantId, shouldAddItem: true, addItemList: newCartItems }));
    dispatch(setUserLastActiveTime(new Date()));
  };

  useEffect(() => {
    if (isValidateBasketSuccess) {
      ChannelManager.BindUser(userParams?.loggedIn).then(() => {
        let navigateToCheckOutObj = { fromFlag, history };
        const validationObj = {
          currencyConversionFactor,
          currencySymbol,
          store,
        };
        cartvalidationCheck({
          isValidated,
          navigateToCheckOutObj,
          validationResult,
          validationObj,
          setMenuCallBack,
          validatedCallFromCart,
        });
        dispatch(resetValidateBasketAction());
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidateBasketSuccess, validationResult, isValidated, dispatch, history, fromFlag]);
  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const discardChangesHandler = (storeVal, disposition, catalogName) => {
    dispatch(
      fetchMenuAction(
        {
          tenantId: tenantId,
          catalogName: catalogName,
        },
        {
          storeId: storeVal?.id,
          channel: SERVICE_CHANNEL,
          service: disposition && getDispositionTypeOnAPIFormat(disposition),
        },
      ),
    );
  };

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
          contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
        }}
        userParams={userParams}
      />
      {renderCartPageComponet({isLoading,params,cartList,onModalOpen,confirmChangesHandler,dispositionNew,history})}
      {showProductListingModal && <ProductListingModalOptions />}
      {(isEmptyObject(segmentedFooterData) && (
        <Footer
          contentData={segmentedFooterData}
          history={history}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
      {userOrderState.cartStateData.showCartState && (unavailableItems.length || priceChangedItems.length) && (
        <CartStatesModule
          unavailableItems={unavailableItems}
          priceChangedItems={priceChangedItems}
          confirmChangesHandler={confirmChangesHandler}
          discardChangesHandler={discardChangesHandler}
        />
      )}
      {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
    </React.Fragment>
  );
};

export default CartPageContainer;
